import React from "react";
import { IResourceComponentsProps, HttpError } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Select, Row, Col } from "antd";
import { ICreateTenant } from "../../models/tenant";

export const TenantCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm<ICreateTenant, HttpError, ICreateTenant>();

  // Transform settings from JSON string to object before submission
  const handleFinish = async (values: any) => {
    const transformedValues = { ...values };
    
    // Parse settings JSON string to object if provided
    if (transformedValues.settings && typeof transformedValues.settings === "string") {
      // Remove leading/trailing whitespace
      const trimmed = transformedValues.settings.trim();
      if (trimmed === "" || trimmed === "null") {
        transformedValues.settings = undefined;
      } else {
        try {
          transformedValues.settings = JSON.parse(trimmed);
        } catch (e) {
          // If invalid JSON, keep as is (will be validated by backend)
          console.error("Failed to parse settings JSON:", e);
        }
      }
    }
    
    // Call the original onFinish with transformed values
    if (formProps.onFinish) {
      return formProps.onFinish(transformedValues);
    }
  };

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} onFinish={handleFinish} layout="vertical">
        <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
              ]}
            >
              <Input placeholder="Enter tenant name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Slug"
              name="slug"
              rules={[
                {
                  required: true,
                  message: "Slug is required",
                },
                {
                  pattern: /^[a-z0-9-]+$/,
                  message: "Slug must be lowercase alphanumeric with hyphens",
                },
              ]}
            >
              <Input placeholder="Enter tenant slug (e.g., acme-corp)" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Status"
              name="status"
              initialValue="active"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                options={[
                  { label: "Active", value: "active" },
                  { label: "Suspended", value: "suspended" },
                  { label: "Trial", value: "trial" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Local API Endpoint"
              name="localApiEndpoint"
              rules={[
                {
                  type: "url",
                  message: "Please enter a valid URL",
                },
              ]}
            >
              <Input placeholder="https://api.example.com" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
          <Col xs={24}>
            <Form.Item
              label="Settings (JSON)"
              name="settings"
              tooltip="Optional JSON object for tenant-specific settings"
            >
              <Input.TextArea
                rows={4}
                placeholder='{"theme": "dark", "timezone": "Europe/Paris"}'
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};

